import { render, staticRenderFns } from "./KPIDirectionMessageInHeader.vue?vue&type=template&id=5ebb527c&scoped=true"
import script from "./KPIDirectionMessageInHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./KPIDirectionMessageInHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./KPIDirectionMessageInHeader.vue?vue&type=style&index=0&id=5ebb527c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebb527c",
  null
  
)

export default component.exports